class HicomNotify implements IHicomNotify {

    // @ts-ignore
    _readUrl: string = `${hicomPage.BaseUrl}/WebApi/Notification/Read`;
    // @ts-ignore
    _clearUrl: string = `${hicomPage.BaseUrl}/WebApi/Notification/Clear`;
    _stackTop: any = {};
    _stackBottomRight: any = {};

    constructor() {
        this.init();
    }

    init() {
        window.addEventListener('load', (event) => {
            // @ts-ignore
            this._stackTop = new PNotify.Stack({
                dir1: "down",
                dir2: "right",
                firstpos1: 25,
                // @ts-ignore
                firstpos2: (window.innerWidth / 2) - (Number(PNotify.defaults.width.replace(/\D/g, '')) / 2),
                modal: false,
                maxOpen: 5
            })
            // @ts-ignore
            this._stackBottomRight = new PNotify.Stack({
                dir1: 'up',
                dir2: 'left',
                firstpos1: 25,
                firstpos2: 25
            })
        })
        window.addEventListener('resize', (event) => {
            // @ts-ignore
            this._stackTop = new PNotify.Stack({
                dir1: "down",
                dir2: "right",
                firstpos1: 25,
                // @ts-ignore
                firstpos2: (window.innerWidth / 2) - (Number(PNotify.defaults.width.replace(/\D/g, '')) / 2),
                modal: false,
                maxOpen: 5
            })
        })
    }

    showNotification(
        title: string,
        text: string,
        notificationType: NotificationType,
        stack: string = null,
        autohide: boolean = true,
        delay: number = 5000,
        textTrusted: boolean = false
    ) {
        try {
            let options = {
                title: title,
                text: text,
                hide: autohide,
                delay: delay,
                stack: this._stackTop,
                textTrusted: textTrusted
            }

            switch (stack) {
                case "stackBottomRight":
                    options.stack = this._stackBottomRight;
                    break;
            }

            switch (notificationType) {
                case NotificationType.Alert:
                    // @ts-ignore
                    PNotify.alert(options);
                    break;
                case NotificationType.Notice:
                    // @ts-ignore
                    PNotify.notice(options);
                    break;
                case NotificationType.Info:
                    // @ts-ignore
                    PNotify.info(options);
                    break;
                case NotificationType.Success:
                    // @ts-ignore
                    PNotify.success(options);
                    break;
                case NotificationType.Error:
                    // @ts-ignore
                    PNotify.error(options);
                    break;
                default:
            }
        } catch (error) {
            console.error('HicomNotify::showNotification - Error:', error);
        }
    }

    clearNotification(notificationAuditId: number) {
        let data = { NotificationAuditId: notificationAuditId };
        // @ts-ignore
        hicomPage.fetchPostJson(this._clearUrl, data)
            .catch((error) => {
                console.error('HicomNotify::clearNotification - Error:', error);
            });
    }

    showNotificationWithRead(
        title: string,
        text: string,
        notificationType: NotificationType,
        stack: string = null,
        autohide: boolean = true
    ) {
        this.showNotification(title, text, notificationType, stack, autohide);

        let elements = document.getElementsByClassName("pnotify-closer");

        let data = { Title: title }

        // @ts-ignore
        hicomPage.fetchPostJson(this._readUrl, data)
            .then((res) => {
                elements[elements.length - 1].addEventListener('click', () => { this.clearNotification(res.Data.id) }, false)
            })
            .catch((error) => {
                console.error('HicomNotify::showNotificationWithRead - Error:', error);
            });
    }

    showPersistentNotification(
        title: string,
        text: string,
        notificationType: NotificationType,
        stack: string
    ) {
        this.showNotification(title, text, notificationType, stack, false);
    }

    showSaveSuccessNotification() {
        this.showNotification("Save complete!", "This record has been successfully saved.", NotificationType.Success);
    }

    showSaveFailureNotification() {
        this.showNotification("Oh no!", "This record could not be saved. Please check for any mandatory fields or try again later.", NotificationType.Error);
    }

    showPublishSuccessNotification() {
        this.showNotification("Publish complete!", "This record has been successfully published.", NotificationType.Success);
    }

    showPublishFailureNotification() {
        this.showNotification("Oh no!", "This record could not be published. Please check for any validation messages or try again later.", NotificationType.Error);
    }

    showUnpublishSuccessNotification() {
        this.showNotification("Unpublish complete!", "This record has been successfully unpublished.", NotificationType.Success);
    }

    showUnpublishFailureNotification() {
        this.showNotification("Oh no!", "This record could not be unpublished. Please check for any validation messages or try again later.", NotificationType.Error);
    }

    showArchiveSuccessNotification() {
        this.showNotification("Archive complete!", "This record has been successfully archived.", NotificationType.Success);
    }

    showArchiveFailureNotification() {
        this.showNotification("Oh no!", "This record could not be archived. Please check for any validation messages or try again later.", NotificationType.Error);
    }

    showUnarchiveSuccessNotification() {
        this.showNotification("Unarchive complete!", "This record has been successfully unarchived.", NotificationType.Success);
    }

    showUnarchiveFailureNotification() {
        this.showNotification("Oh no!", "This record could not be unarchived. Please check for any validation messages or try again later.", NotificationType.Error);
    }

    showDeleteSuccessNotification() {
        this.showNotification("Delete complete!", "This record has been successfully deleted.", NotificationType.Success);
    }

    showDeleteFailureNotification() {
        this.showNotification("Oh no!", "This record could not be deleted. Please check for any validation messages or try again later.", NotificationType.Error);
    }

    sendDesktopNotification(
        title: string,
        message: string
    ) {
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
        }
        else if (Notification.permission === "granted") {
            let options = {
                body: message
            }
            let notification = new Notification(title, options);
        }
        else if (Notification.permission !== "denied") {
            Notification.requestPermission().then(function (permission) {
                if (permission === "granted") {
                    let options = {
                        body: message
                    }
                    let notification = new Notification(title, options);
                }
            });
        }
    }
}

enum NotificationType {
    Alert,
    Notice,
    Info,
    Success,
    Error
}